module.exports = __webpack_public_path__ + "static/media/square_checkmark_active_pb.654fce84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/square_checkmark_active_pb.svg
// module id = 16
// module chunks = 0